export default "__VITE_ASSET__CBmghIWc__"